<div *ngIf="block && carouselNews && carouselNews.length">
  <h4>{{block.titolo_blocco}}</h4>
  <owl-carousel-o *ngIf="helpersService.isBrowser" [options]="customOptionsOwl">
      <ng-template carouselSlide *ngFor="let slide of carouselNews;">     
        <div class="card">
          <a [routerLink]="navigationService.splitUrlRouterLink(slide.field_link).path" [queryParams]="navigationService.splitUrlRouterLink(slide.field_link).queryParams"><img loading="lazy" [src]="domainWebsite + slide.field_immagine_cover" alt="image description" class="card-img-top"></a>
          <div class="card-body">
            <a [routerLink]="navigationService.splitUrlRouterLink(slide.field_link).path" [queryParams]="navigationService.splitUrlRouterLink(slide.field_link).queryParams"><h5 class="card-title truncate" [title]="slide.Titolo">{{slide.Titolo}}</h5></a>
            <p class="card-text" [innerHTML]="slide.Testo_news"></p>
          </div>
        </div> 
      </ng-template>
  </owl-carousel-o>
  <div *ngIf="!helpersService.isBrowser">
    <ng-container *ngFor="let slide of carouselNews;">
      <div class="card">
        <img loading="lazy" [src]="domainWebsite + slide.field_immagine_cover" alt="image description" class="card-img-top">
        <div class="card-body">
          <h5 class="card-title truncate" [title]="slide.Titolo">{{slide.Titolo}}</h5>
          <p class="card-text" [innerHTML]="slide.Testo_news"></p>
        </div>
      </div>
    </ng-container>
  </div>
</div>